// import { getExtensionPreviewStyles, multiImageInnerCarouselStyles } from '@bingads-webui-campaign-react/shared-image-preview-styles';
// import { floatButtonStyle, underlineLinkStyle, reactUIBlockerStyle  } from './shared-styles-from-theme-fluent';
// import { uurlTestToolStyle } from '../uurl-test-tool-style';
// import { customParametersStyle } from '../custom-parameters-style';
import { uurlStyle } from '../uurl-style';
// import { selectElementStyle } from './select-element-style';
// import { imageExperienceContentStyle } from './image-experience-content-style';
// import { modalContainerStyle } from './modal-container-style';
// import { editImageCommonStyle } from './edit-image-common-style';

// this style is in right panel, must be scoped by a feature's selector using panelClassName, for example
export const extensionEditorNewStyles = (components, theme) => ({
  '& .extension-editor__container': {
    '& .form-horizontal': {
      '& .form-group': {
        marginLeft: 0,
        marginRight: 0,
      },

      '& .form-group ~ .form-group': {
        marginTop: 16,
      },

      '& .control-label': {
        textAlign: 'left',
        float: 'none',
        width: '100%',
      },

      // SimpleForm
      '& .form-label-container': {
        float: 'none',
      },

      // Ad extension editors' specific
      '& .control-value': {
        float: 'none',
        // '& .form-input-container[data-property="IsCallTrackingEnabled"]': {
        //   '& .radio label': {
        //     ...underlineLinkStyle({ palette }),
        //   },
        // },
      },

      // Legacy controls' styles
      // inlineSelectWrapper.pug - not sure it is used in ad extensions
      // '& .selectorControl': {
      //   marginTop: 10,
      //   minWidth: 1000,
      // },

      '& .input-group .form-control': {
        marginBottom: 10,
      },

      '& .input-group .input-group-addon': {
        backgroundColor: 'transparent',
        borderWidth: 0,
        position: 'absolute',
        top: 0,
        right: '15px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        color: 'gray',
      },

      // Collapse icon
      '& .expandedImage, & .expanderImage': {
        display: 'inline-block',
        fontFamily: theme.iconFontFamily,
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: '1',
        marginLeft: 10,
        marginRight: 4,
      },

      '& .expanderImage': {
        verticalAlign: 'top',
        '&:before': {
          lineHeight: '1.7',
          content: '"\\E96E"',
        },
      },
      '& .expandedImage:before': {
        content: '"\\E96D"',
      },

      // Upgraded URL controls
      ...uurlStyle(components, theme),

      // Ad extension's own legacy scheduling control
      '& .dayTimeRange': {
        '& select.form-control': {
          width: 'auto',
          marginBottom: 5,
        },
        '& select.form-control.hour-select': {
          marginLeft: 5,
          marginRight: 5,
        },
        '& select.form-control.minute-select': {
          marginLeft: 5,
          marginRight: 5,
        },
        '& .filtercloseimage': {
          fontFamily: theme.iconFontFamily,
          color: theme.palette.neutralSecondary,
          cursor: 'pointer',
          right: -8,
          top: 0,
          paddingTop: 0,
          position: 'relative',
        },
        '& .filtercloseimage:before': {
          content: '"\\E711"',
        },
      },

      // Alert blocks
      '& .alert': {
        width: 625,
        display: 'block',
      },
      '& .alert-image': {
        float: 'left',
        marginTop: 5,
      },
      '& .alert-info-inline': {
        marginBottom: 10,
      },

      // Save bar
      '.save-bar': {
        '& .btn.btn-primary': {
          marginRight: 10,
        },
      },


      // Some hack around Kendo pickers
      // '& .k-picker-wrap.k-state-default .k-select .k-icon.k-i-calendar': {
      //   display: 'none',
      // },
    },
  },
  // '.extension-editor__container, .image-ad-extension-v2-edit': {
  //   '& .error': {
  //     color: '#D90026',
  //     fontSize: 12,
  //   },


  //   '& .form-groups-with-sidebar': {
  //     '&  .sidebar': {
  //       position: 'absolute',
  //       top: 150,
  //       left: 400,
  //       right: 10,
  //       height: '10%',
  //     },

  //     '& .sidebar__right-bracket': {
  //       float: 'left',
  //       height: '100%',
  //       width: 10,
  //       margin: '5px 30px',
  //       borderWidth: '1px 1px 1px 0',
  //       borderStyle: 'solid',
  //       borderColor: 'darkgray',
  //     },

  //     '& .sidebar__content': {
  //       float: 'left',
  //       height: '100%',
  //     },

  //     '& .sidebar__content_aggregate-length': {
  //       display: 'flex',
  //       flexDirection: 'column',
  //       justifyContent: 'center',
  //     },
  //   },


  //   '& .font-error': {
  //     color: '#D90026',
  //     fontSize: 12,
  //   },

  //   '& .string-list-input .side-close-image': {
  //     position: 'relative',
  //     top: -35,
  //     left: 185,
  //   },

  //   '& .HelpTopic a': {
  //     textDecoration: 'underline',
  //   },
  // },


  // '[data-type="AppAdExtension"]': {
  //   '& [data-property="DestinationUrl"]': {
  //     '& .form-label-container': {
  //       width: 300,
  //     },
  //   },
  // },
  // '[data-type="ReviewAdExtension"]': {
  //   '& [data-property="Url"]': {
  //     '& .form-input-container': {
  //       width: 400,
  //     },
  //     '& .url-field': {
  //       width: 275,
  //     },
  //   },
  // },
  // '[data-type="CallAdExtension"]': {
  //   '& input[type=radio]': {
  //     float: 'left',
  //   },
  // },
  // '[data-type="StructuredSnippetAdExtension"]': {
  //   '& button.btn-link.add-row': {
  //     color: '#0078d4',
  //   },
  // },

  // '.cx-select .structured-snippet-category-layer-1': {
  //   marginRight: '10px',
  //   width: '25%',
  //   float: 'left',
  // },
  // '.cx-select .structured-snippet-category-layer-2': {
  //   width: '70%',
  //   float: 'right',
  // },

  // '[data-type="FilterLinkExtension"]': {
  //   '& .alert': {
  //     width: '100%',
  //   },
  // },
  // '[data-type="PromotionExtension"]': {
  //   '& .alert': {
  //     width: '100%',
  //   },
  // },
  // '[data-type="FlyerExtension"]': {
  //   '& .alert': {
  //     width: '100%',
  //   },
  // },
  // '[data-type="VideoExtension"]': {
  //   '& .alert': {
  //     width: '100%',
  //   },
  // },

  // '.automated-extensions__options-container': {
  //   '& input[type=checkbox]': {
  //     float: 'left',
  //   },
  //   '& input[type=radio]': {
  //     float: 'left',
  //   },
  //   '& .label__text': {
  //     marginLeft: 10,
  //   },
  //   '& .justification__input': {
  //     marginBottom: 20,
  //   },
  //   '& .opt-out__checkboxes label': {
  //     marginLeft: 10,
  //     paddingLeft: 20,
  //   },
  //   '& .form-horizontal .form-label-container': {
  //     paddingLeft: 0,
  //   },
  //   '& .radio label': {
  //     paddingLeft: 5,
  //     color: palette.neutralPrimary,
  //   },
  //   '& .control-label span': {
  //     color: palette.neutralPrimary,
  //   },
  //   '& .radio .label__text': {
  //     marginLeft: 0,
  //   },
  //   '& li.opt-out__checkbox input': {
  //     marginRight: 5,
  //   },
  //   '& .automated-extensions__options panel': {
  //     '& .panel-heading': {
  //       marginBottom: 10,
  //     },
  //   },
  //   '& .label__sub-text': {
  //     color: '#605e5c',
  //     fontWeight: 'normal',
  //   },
  // },

  // '.img-editor-list-group': {
  //   border: '1px solid #BBBBBB',
  //   background: '#FFFFFF',
  //   width: '100%',
  //   height: 295,
  //   padding: 11.5,
  // },

  // '.img-editor-selected-list': {
  //   border: '1px solid #BBBBBB',
  //   background: '#FFFFFF',
  //   height: 150,
  //   padding: 15,
  //   display: 'inline-block',

  //   '& .selected-img-description': {
  //     textAlign: 'center',
  //     height: 10,
  //     marginTop: 10,
  //     fontWeight: 'bold',
  //   },
  // },

  // '.img-editor': {
  //   '& .imgEditor-form .col-sm-4': {
  //     marginLeft: 0,
  //   },
  //   '& ul[role=radiogroup]': {
  //     marginLeft: 0,
  //   },
  //   '& .ui-tabs-selected .btn': {
  //     backgroundColor: '#E7F0F6;',
  //   },
  //   '& .img-editor-selected-img': {
  //     position: 'relative',
  //     width: '100px',
  //     height: '100%',
  //     marginLeft: 10,
  //     marginRight: 10,
  //     backgroundColor: '#F2F2F2',
  //     '& img': {
  //       backgroundColor: '#F2F2F2',
  //       width: '100px',
  //       height: '100px',
  //     },
  //     '& .image-selected & img': {
  //       border: 'none',
  //       backgroundColor: '#FFFFFF',
  //     },
  //     '&.image-selected &:hover': {
  //       opacity: 0.5,
  //     },
  //   },
  //   '& .selected-img-delete-icon': {
  //     fontFamily: iconFontFamily,
  //     height: 12,
  //     width: 12,
  //     position: 'absolute',
  //     top: 1,
  //     right: 1,
  //     '.image-selected .img-editor-selected-img:hover &': {
  //       display: 'block',
  //     },
  //     '&:hover': {
  //       cursor: 'pointer',
  //       backgroundColor: '#DDEEFF',
  //     },
  //     '&:before': {
  //       content: '"\\E711"',
  //     },
  //   },
  //   '& .img-editor-ratio-list': {
  //     width: '100%',
  //     float: 'left',
  //     display: 'none',
  //   },
  //   '& .img-editor-ratio-list.ratio12x10': {
  //     display: 'block',
  //   },
  //   '& .img-editor-selected-listitem': {
  //     float: 'left',
  //   },
  //   '& .image-preview': {
  //     maxWidth: '50%',
  //     maxHeight: '25%',
  //   },
  //   '& .imgEditor-listitem': {
  //     display: 'inline-block',
  //     position: 'relative',
  //     '.img-editor-ratio-list &': {
  //       margin: 4.5,
  //     },
  //     '.img-editor-ratio-list & img': {
  //       width: '100%',
  //       height: '100%',
  //     },
  //     '.ratio12x10 &': {
  //       width: 100,
  //       height: 83,
  //     },
  //     '.ratio4x3 &': {
  //       width: 100,
  //       height: 75,
  //     },
  //     '.ratio3x2 &': {
  //       width: 100,
  //       height: 67,
  //     },
  //     '.ratio16x9 &': {
  //       width: 100,
  //       height: 56,
  //     },
  //     '.img-preview': {
  //       width: 160,
  //       height: 90,
  //     },
  //   },
  //   '& .imgEditor-listitem img': {
  //     cursor: 'pointer',
  //     border: '3px white solid',
  //     '&:hover': {
  //       border: '3px #1570A6 solid',
  //     },
  //   },
  //   '& .imgEditor-listitem-delete': {
  //     fontFamily: iconFontFamily,
  //     fontSize: 12,
  //     fontWeight: 'normal',
  //     lineHeight: 1,
  //     right: 10,
  //     top: 10,
  //     position: 'absolute',
  //     '&:hover': {
  //       cursor: 'pointer',
  //       backgroundColor: '#DDEEFF',
  //     },
  //     '&:before': {
  //       content: '"\\E711"',
  //     },
  //   },
  //   '& .crop-item': {
  //     float: 'left',
  //     marginRight: 20,
  //   },
  //   '& .radio input[type="radio"]': {
  //     float: 'left',
  //   },
  //   '& .radio label': {
  //     display: 'inline',
  //   },
  //   '& .btn-group li': {
  //     float: 'left',
  //   },
  //   '& .col-sm-offset-2': {
  //     marginLeft: 0,
  //   },
  //   '& .col-sm-4': {
  //     marginLeft: 20,
  //   },
  //   '& .form-group .col-sm-10': {
  //     width: 700,
  //     float: 'none',
  //   },
  // },

  // '.imgEditor-container-edit-ps4n': {
  //   marginLeft: 20,
  //   '& .media-object': {
  //     float: 'left',
  //     marginRight: 10,
  //   },
  // },

  // '.imgEditor-crop': {
  //   height: 212,
  // },

  // '.img-editor-crop': {
  //   border: '1px solid #FFFFFF',
  //   padding: 5,
  //   display: 'inline-block',
  //   background: '#FFFFFF',
  //   minWidth: 800,
  // },

  // '.crop-item': {
  //   display: 'inline-block',
  //   margin: 10,

  //   '& img': {
  //     marginBottom: 5,
  //   },
  // },

  // '.img-editor-menu': {
  //   border: '1px solid #FFFFFF',
  //   float: 'right',
  // },

  // '.imgeditor-save-container': {
  //   paddingTop: 15,
  // },

  // '.image-cropper': {
  //   minWidth: 720,

  //   '& .crop-area': {
  //     maxWidth: 720,
  //     marginTop: 20,
  //   },

  //   '& .imgEditor-crop': {
  //     marginTop: 5,
  //   },

  //   '& .image-extension-preview': {
  //     marginTop: 10,
  //     marginBottom: 20,

  //     '& .mediaBody': {
  //       position: 'relative',
  //     },

  //     '& .note-creation-review': {
  //       marginTop: 15,
  //       width: 300,
  //     },

  //     '& .note-crop-preview': {
  //       marginTop: -3,
  //       fontSize: 9,
  //     },

  //     '& .display-url': {
  //       position: 'absolute',
  //       bottom: 0,
  //       fontSize: 9,
  //       color: '#727272',
  //       whiteSpace: 'nowrap',
  //     },

  //     '& .brand-logo-placeholder': {
  //       width: 20,
  //       height: 20,
  //       display: 'inline-block',
  //       background: '#999',
  //       verticalAlign: 'middle',
  //       marginRight: 10,
  //     },
  //   },
  // },

  // '.jcrop-handle': {
  //   backgroundColor: 'rgba(255, 255, 255, 0)',
  //   opacity: 1,
  //   width: 20,
  //   height: 20,

  //   '&.ord-ne': {
  //     borderRight: '5px #000000 solid',
  //     borderTop: '5px #000000 solid',
  //     top: 0,
  //     right: 0,
  //   },
  //   '&.ord-se': {
  //     borderRight: '5px #000000 solid',
  //     borderBottom: '5px #000000 solid',
  //     bottom: 0,
  //     right: 0,
  //   },
  //   '&.ord-nw ': {
  //     borderLeft: '5px #000000 solid',
  //     borderTop: '5px #000000 solid',
  //     top: 0,
  //     left: 0,
  //   },
  //   '&.ord-sw': {
  //     borderLeft: '5px #000000 solid',
  //     borderBottom: '5px #000000 solid',
  //     bottom: 0,
  //     left: 0,
  //   },
  // },

  // '.image-picker': {
  //   '& .drop-picker-area': {
  //     height: 150,
  //     width: '100%',
  //     border: 'dashed',
  //     color: 'gray',
  //     position: 'relative',
  //     '& div': {
  //       position: 'absolute',
  //       height: '100%',
  //       width: '100%',
  //     },
  //     '& .drop-area': {
  //       padding: 10,
  //       '& .add-image-text': {
  //         textAlign: 'center',
  //         position: 'relative',
  //         top: '50%',
  //         transform: 'translateY(-50%)',
  //       },
  //     },
  //     '& img': {
  //       maxWidth: '95%',
  //       maxHeight: '95%',
  //     },
  //   },
  // },

  // '.jcrop-holder': {
  //   '.jcrop-tracker': {
  //     height: '100%',
  //     width: '100%',
  //   },
  //   '.jcrop-keymgr': {
  //     visibility: 'hidden',
  //   },
  // },

  // '#selector-control-container': {
  //   background: '#FFFFFF',
  //   boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
  //   borderRadius: '0px 0px 2px 2px',
  //   marginLeft: 15,
  //   width: '90%',
  //   minWidth: 1000,
  // },


  // '.k-overlay': {
  //   zIndex: '10000 !important',
  // },
  // '.k-widget.k-window': {
  //   zIndex: '10001 !important',
  //   minWidth: '750px !important',

  //   '& a.HelpTopic': {
  //     textDecoration: 'underline',
  //   },
  // },

  // '.image-ad-extension-v2-edit': {
  //   '& .image-experience-content': {
  //     marginBottom: '10px',
  //   },
  //   '& .add-image-button': {
  //     background: `${palette.white} !important`,
  //     border: `1px solid ${palette.neutralSecondaryAlt}`,
  //     borderRadius: 2,
  //     boxSizing: 'border-box',
  //     fontWeight: 600,
  //     margin: '0 !important',

  //     '&:before': {
  //       color: palette.themePrimary,
  //       content: '"\\E710"',
  //       fontFamily: iconFontFamily,
  //       fontWeight: 'normal',
  //       marginRight: 8,
  //     },
  //   },
  //   '& .col-sm-4.control-label': {
  //     float: 'none',
  //     textAlign: 'left',
  //   },
  //   '& .extension-editor__extra': {
  //     '& .fieldItemAd': {
  //       '& .radio': {
  //         margin: 0,
  //         float: 'left',
  //         '& label': {
  //           paddingLeft: 0,
  //           paddingRight: 10,

  //         },
  //         '& input[type=radio]': {
  //           marginLeft: 0,
  //           bottom: 0,
  //         },
  //       },
  //     },
  //   },
  //   '& input[type=checkbox].single-eligible-checkbox': {
  //     marginLeft: 0,
  //     marginRight: 10,
  //     float: 'left',
  //   },
  //   '& input[type=checkbox].multi-eligible-checkbox': {
  //     marginLeft: 0,
  //     marginRight: 10,
  //     float: 'left',
  //   },
  //   '& .scheduling-form': {
  //     '& .radio': {
  //       '& label': {
  //         paddingLeft: 0,
  //         '& input[type=radio]': {
  //           marginLeft: 0,
  //           bottom: 0,
  //         },
  //       },
  //     },
  //   },
  //   '& .extension-images-control': {
  //     '& .image-section-label': {
  //       display: 'inline-block',
  //       '& label': {
  //         float: 'left',
  //       },
  //       '& .helpbutton': {
  //         float: 'left',
  //       },
  //     },
  //     '& .add-image-button': {
  //       display: 'block',
  //     },
  //   },
  //   '& .image-experience-content .image-list-view-content': {
  //     position: 'relative',
  //     '& .image-list': {
  //       '& .image-list-label': {
  //         fontSize: 14,
  //         fontWeight: 600,
  //         lineHeight: '19px',
  //       },

  //       '& .image-list-content': {
  //         display: 'flex',
  //         border: '1px solid #C8C8C8',
  //         margin: '8px 0 0 0',
  //         padding: '16px 16px 12px 16px',
  //         width: 'fit-content',

  //         '& .image-list-item': {
  //           float: 'none',
  //           padding: 0,

  //           '& ~ .image-list-item': {
  //             marginLeft: 8,
  //           },

  //           '& .dropdown.btn-group': {
  //             display: 'block',

  //             '&.image-edit-dropdown .dropdown-toggle': {
  //               extend: floatButtonStyle({ palette }).floatButton,
  //               fontFamily: iconFontFamily,
  //               fontSize: 16,
  //               lineHeight: 1,
  //               float: 'right',
  //               margin: 0,

  //               '&:before': {
  //                 content: '"\\E70F"',
  //               },
  //             },

  //             '& .caret': {
  //               display: 'none',
  //             },
  //           },

  //           '& .image-item-ratio-label': {
  //             fontSize: 14,
  //             lineHeight: '20px',
  //           },
  //         },

  //         '& .remove-all-button': {
  //           background: 'none',
  //           border: 'none',
  //           color: palette.neutralSecondary,
  //           fontFamily: iconFontFamily,
  //           fontSize: 12,
  //           lineHeight: 1,
  //           margin: '-14px -14px 0 0',
  //           padding: 8,
  //           width: 28,
  //           height: 28,

  //           '&:before': {
  //             content: '"\\E711"',
  //           },
  //         },
  //       },
  //     },
  //   },
  //   '& .image-experience-content .image-list-view-content .remove-all-button': {
  //     marginBottom: 5,
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list': {
  //     margin: '10px 0',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-label': {
  //     fontSize: 12,
  //     fontWeight: '700',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item': {
  //     border: 'none',
  //     position: 'relative',
  //     float: 'left',
  //     padding: 5,
  //     fontSize: 12,
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-item-ratio-label': {
  //     marginTop: 5,
  //     height: '20px !important',
  //     textAlign: 'center',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item:hover .image-list-item-image .dropdown.btn-group': {
  //     display: 'block',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item:focus': {
  //     outline: 'none !important',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image': {
  //     position: 'relative',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group': {
  //     display: 'none',
  //     position: 'absolute',
  //     width: '100%',
  //     bottom: '0',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group.image-edit-dropdown .dropdown-toggle': {
  //     color: 'white',
  //     background: 'rgba(0,0,0,0.3)',
  //     width: '100%',
  //     border: '0',
  //     padding: 2,
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group .dropdown-menu': {
  //     margin: '0',
  //     borderRadius: '0',
  //     border: '2px solid rgba(0,0,0,0.15)',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group .dropdown-menu li': {
  //     float: 'unset',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item .image-list-item-image .dropdown.btn-group .dropdown-menu li a': {
  //     paddingLeft: 10,
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item.empty-image-list-item button': {
  //     border: 'dashed',
  //     background: 'white',
  //     borderColor: '#CCCCCC',
  //     borderWidth: 'thin',
  //     color: '#00a2ff',
  //     textAlign: 'center',
  //   },
  //   '& .image-experience-content .image-list-view-content .image-list .image-list-item.empty-image-list-item button:focus': {
  //     outline: 'none !important',
  //   },
  //   '& .new-preview-carousel-container': {
  //     // inner carousel in a carousel
  //     border: '1px solid #C8C8C8',
  //     margin: 0,
  //     width: '100%',
  //     minWidth: 669,
  //     ...multiImageInnerCarouselStyles(palette, iconFontFamily),

  //     '& .new-responsive-ad-preview-container': {
  //       height: 500,
  //       overflow: 'hidden',

  //       '& .responsive-ad-preview-content': {
  //         border: '1px solid #C8C8C8',
  //       },

  //       '& .preview-type-string': {
  //         bottom: 25,
  //         fontSize: 14,
  //         lineHeight: '20px',
  //         paddingTop: 12,
  //       },
  //     },

  //     '& .disclaimer-info, & .additional-disclaimer': {
  //       fontSize: 12,
  //       lineHeight: '20px',
  //       textAlign: 'left',
  //     },

  //     '& .disclaimer-info': {
  //       padding: '0 24px 20px 24px',
  //     },

  //     '& .additional-disclaimer': {
  //       bottom: 0,
  //       padding: '0 24px',
  //     },
  //   },
  //   '& .new-responsive-ad-preview-container': {
  //     fontFamily: '"Segoe UI","Segoe WP",Arial,Sans-Serif',
  //     fontSize: 10,
  //     height: 540,
  //     position: 'relative',
  //   },
  //   '& .new-responsive-ad-preview-container .responsive-ad-preview-content': {
  //     boxSizing: 'unset',
  //     position: 'absolute',
  //     top: '47%',
  //     left: '50%',
  //     transform: 'translate(-50%, -50%)',
  //     margin: '0',
  //     overflow: 'hidden',
  //   },
  //   '& .new-responsive-ad-preview-container .preview-type-string': {
  //     position: 'absolute',
  //     bottom: 50,
  //     fontSize: 12,
  //     textAlign: 'center',
  //     width: '100%',
  //   },
  //   '& .image-experience-content .logo-item .logo-image-container .dropdown.btn-group .dropdown-menu li': {
  //     float: 'unset',
  //   },
  //   ...imageExperienceContentStyle(),
  //   ...modalContainerStyle(palette),
  //   ...editImageCommonStyle(),
  // },
  // '.new-responsive-ad-preview-container': {
  //   ...getExtensionPreviewStyles(),
  // },
  // '.add-image-content-container .add-image-content': {
  //   '& .aspect-ratio-choice-group-stack': {
  //     display: 'inline-flex',
  //     marginLeft: 10,
  //   },
  //   '& .aspect-ratio-choice-group': {
  //     display: 'inline-flex',
  //     marginLeft: 10,
  //     '& .ms-ChoiceFieldGroup-flexContainer': {
  //       display: 'inline-flex',
  //       '& .ms-ChoiceField': {
  //         marginRight: 10,
  //         marginTop: 4,
  //         '& label': {
  //           paddingTop: 0,
  //         },
  //       },
  //     },
  //   },
  //   '& .image-picker-container': {
  //     marginTop: 15,
  //     marginBottom: 5,
  //     backgroundColor: 'transparent',
  //     padding: 15,
  //     border: 0,
  //   },
  //   '& .nav-pills.pill-control': {
  //     marginBottom: '15px',
  //     border: 'none',
  //     '& li': {
  //       border: 'none',
  //       '& a': {
  //         border: 'none',
  //         background: '#F3F2F1',
  //         color: palette.neutralPrimary,
  //       },
  //       '&:hover': {
  //         '& a': {
  //           background: '#EDEBE9',
  //         },
  //       },
  //       '&:focus': {
  //         '& a': {
  //           background: '#F3F2F1',
  //           border: '1px solid #605E5C',
  //         },
  //       },
  //     },
  //     '& li.active': {
  //       '& a': {
  //         background: '#EFF6FC',
  //         color: palette.neutralPrimary,
  //         fontWeight: 600,
  //       },
  //       '&:hover': {
  //         '& a': {
  //           background: '#C7E0F4',
  //         },
  //       },
  //     },
  //     '& .pill-item-label-container': {
  //       top: -7,
  //       color: '#ffffff',
  //       right: -15,
  //       border: '1px solid #ffffff',
  //       display: 'inline-block',
  //       padding: '0 9px',
  //       zIndex: 1,
  //       position: 'absolute',
  //       fontSize: 12,
  //       borderRadius: 12,
  //       backgroundColor: '#D83B01',
  //     },
  //   },
  //   '& .react-block-ui > div:last-child > div > div': {
  //     display: 'inline-flex',
  //   },
  //   ...reactUIBlockerStyle(palette),
  // },
  // '.action-language': {
  //   '& .actionextension-search-dropdown-container': {
  //     '& .dropdown-menu': {
  //       marginLeft: 0,
  //     },
  //   },
  // },
  // '.action-text': {
  //   '& .actionextension-search-dropdown-container': {
  //     '& .dropdown-menu': {
  //       marginLeft: 0,
  //     },
  //   },
  // },
});
